import { IComponentNode, IPage } from 'app/app/editor/index.functions';
import { generateUid, processPageContainersUid } from 'app/app/editor/page/index';
import { getNodeWithParentByUid } from 'app/app/editor/page/getNodeByUid';

export default function insertNodeIntoPage(
    scrPage: IPage,
    node: IComponentNode,
    insertIntoUid: string,
    insertAfterUid?: string | number,
    removeSrc?: boolean,
) {
    const newPage = structuredClone(scrPage);
    const newNode = structuredClone(node);
    const updateNodeUid = (node: IComponentNode) => {
        if (node.type == 'component') {
            const oldComponent = newPage.components[node.params.uid];
            node.params.uid = generateUid(newPage.components, oldComponent.component);
            newPage.components[node.params.uid] = structuredClone(oldComponent);
        } else {
            if (node.elements) {
                node.elements.forEach((n) => {
                    updateNodeUid(n);
                });
            }
        }
    };

    if (removeSrc) {
        const nodeData = getNodeWithParentByUid(newPage.layout, node.params.uid);
        if (!nodeData) {
            return newPage;
        }
        nodeData.parentNode.elements![nodeData.nodeIndex].params.uid = '__mark';
    } else {
        updateNodeUid(newNode);
    }

    let container = newPage.layout;
    if (insertIntoUid != 'page') {
        const insertInto = getNodeWithParentByUid(newPage.layout, insertIntoUid);
        if (!insertInto) {
            return newPage;
        }
        container = insertInto.node.type == 'container' ? insertInto.node : insertInto.parentNode;

        if (insertInto.node.type == 'component' && !insertAfterUid) {
            insertAfterUid = insertIntoUid;
        }
    }

    if (!container.elements) {
        container.elements = [];
    }

    if (typeof insertAfterUid == 'number') {
        container.elements.splice(insertAfterUid, 0, newNode);
    } else {
        let index = -1;
        if (insertAfterUid) {
            index = container.elements.findIndex(
                (element: any) => element?.params?.uid && element.params.uid == insertAfterUid,
            );
        }
        if (index > -1) {
            container.elements.splice(index + 1, 0, newNode);
        } else {
            container.elements.push(newNode);
        }
    }

    processPageContainersUid(newPage.layout, 'container');

    if (removeSrc) {
        const oldNode = getNodeWithParentByUid(newPage.layout, '__mark');
        if (oldNode) {
            oldNode.parentNode.elements?.splice(oldNode.nodeIndex, 1);
        }
    }

    processPageContainersUid(newPage.layout, 'container');
    return newPage;
}
